/* eslint-disable react-hooks-ext/exhaustive-deps -- TODO(react-hooks): 1 hook(s) need dependency review; fix each and remove this directive */
import { useTranslation } from "@i18n";
import type { TranslatedString } from "@i18n";
import { useState, useEffect, useCallback } from "react";
import { formUserSettingsController } from "@Actions/Forms";
import { useDispatch, useSelector } from "react-redux";
import { TOAST_TYPE_ERROR, TOAST_TYPE_SUCCESS, TOAST_TYPE_WARNING } from "@Services/constants";
import { showToastNotification } from "@Reducers/toastSlice";
import { formCategoryObject } from "@Features/portal-settings/components/PortalSetings/Configuration/FormsAndFields/constants";
import { RootState } from "@Reducers/index";

function useFromList({ projectId, formCategory, isFocused = true, showOnlyGrid = false }: any) {
  const { t } = useTranslation();
  const [userSettingsExists, setUserSettingsExists] = useState(false);
  const [showWarning, setShowWarning] = useState<any>({ status: false });
  const [moduleTxt, setModuleTxt] = useState("");

  const dispatch = useDispatch();

  const customModules = useSelector((state: RootState) => state.customModules) || [];

  const getUserSettingsForFormConfig = useCallback(async () => {
    const checkUserSettingExists = (await formUserSettingsController({
      action: "checkFormUserSettings",
      projectId,
      resourceType: formCategory,
    })) as any;
    setUserSettingsExists(!!checkUserSettingExists.data?.isUserSettingExists);
  }, [projectId, formCategory]);

  useEffect(() => {
    if (isFocused && !showOnlyGrid && projectId) {
      getUserSettingsForFormConfig();
    }
  }, [formCategory, isFocused, projectId, showOnlyGrid, getUserSettingsForFormConfig]);

  useEffect(() => {
    if (customModules.length) {
      const categoryObj = customModules.find((module: any) => module.resourceType == formCategory);
      const moduleText = categoryObj?.activeCell || formCategoryObject[formCategory]?.activeCell || "";

      setModuleTxt(moduleText);
    } else {
      setModuleTxt(formCategoryObject[formCategory]?.activeCell ?? "");
    }
  }, [customModules, formCategory]);

  const showWarningModal = (source: any) => {
    setShowWarning({ status: true, source });
  };
  const hideWarningModal = () => {
    setShowWarning({ status: false });
  };

  async function resetConfig() {
    if (userSettingsExists) {
      const res = (await formUserSettingsController({
        action: "deleteFormUserSettings",
        projectId,
        resourceType: formCategory,
      })) as any;
      if (res.data.status) {
        dispatch(
          showToastNotification({
            content: t("Config reseted successfully") as TranslatedString,
            type: TOAST_TYPE_SUCCESS,
          }),
        );
        setUserSettingsExists(false);
        hideWarningModal();
      } else {
        hideWarningModal();
        dispatch(
          showToastNotification({
            content: res.data.errorMessage,
            type: TOAST_TYPE_ERROR,
          }),
        );
      }
    } else {
      dispatch(
        showToastNotification({
          content: t("User settings do not exists") as TranslatedString,
          type: TOAST_TYPE_WARNING,
        }),
      );
    }
  }

  function resetConfigClick() {
    if (userSettingsExists) {
      showWarningModal("resetConfig");
    } else {
      dispatch(
        showToastNotification({
          content: t("User settings does not exists") as TranslatedString,
          type: TOAST_TYPE_WARNING,
        }),
      );
    }
  }

  return {
    userSettingsExists,
    resetConfig,
    getUserSettingsForFormConfig,
    showWarning,
    setShowWarning,
    showWarningModal,
    hideWarningModal,
    resetConfigClick,
    moduleTxt,
  };
}

export default useFromList;
